<template>
  <div class="table-list-page">
    <search-nav v-if="showNav" @handleSearch="onClickSearch">
      <slot name="search"/>
    </search-nav>
    <div class="w-full text-right mb-4">
      <vs-button v-if="download"
                 class="mr-4" color="secondary" type="border"
                 @click="onClickDownload">{{ $t('button.Excel 다운로드') }}
      </vs-button>

      <vs-button v-if="approval"
                 class="mr-4" color="secondary" type="border"
                 @click="onClickApprovalLine">{{ $t('button.결재선 지정') }}
      </vs-button>

      <vs-button v-if="create"
                 class="" color="secondary"
                 @click="onClickNew">{{createBtnLabel}}
      </vs-button>
    </div>

    <!-- stripe
        :sst="true"-->
    <vx-card :class="cardClass">
      <vs-table
        class="pb-wide"
        color="success"
        ref="table"

        :sst="true"
        :data="realList"
        @sort="onClickSort"
        @selected="onClickDetail">

        <!--        <template slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">-->

        <!--          &lt;!&ndash;-->
        <!--            [Per Page] : 한 페이지에 보여지는 게시글 수를 설정하는 드롭다운-->
        <!--            드롭다운에 노출되는 아이템을 추가하려면, props.perPage 에 콤마(,)로 구분하여 넣으면 된다.-->

        <!--            ex) per-page="10,20,30"-->
        <!--          &ndash;&gt;-->
        <!--          <vs-select-->
        <!--            v-if="enablePerPageDropDown"-->
        <!--            autocomplete-->
        <!--            v-model="boardPerPage"-->
        <!--            class="fix-perpage mb-4"-->
        <!--            @change="handleChangePerPage">-->
        <!--            <vs-select-item :key="index" :value="item.value" :text="item.text"-->
        <!--                            v-for="(item,index) in itemsPerPageOptions"/>-->
        <!--          </vs-select>-->
        <!--        </template>-->

        <template slot="thead">
          <vs-th v-if="baseColumn" sort-key="No" style="width: 60px; min-width: 60px; text-align: center;"><span class="w-full text-center">No.</span></vs-th>
          <vs-th v-for="head in heads" :key="`table_header_${head.name}`"
                 class="page-head"

                 :class="head.class"
                 :style="head.style"
                 style="text-align: center;"
                 :sort-key="head.name">
            <span class="w-full">{{ head.name }}</span>
          </vs-th>
          <vs-th v-if="baseColumn && !(boardId && boardId > 0)" sort-key="결재상태" style="min-width:100px; "><span class="w-full text-center">결재상태</span></vs-th>
          <vs-th v-if="baseColumn && moveProject" style="min-width:100px; "><span class="w-full text-center">보기</span></vs-th>

        </template>

        <template slot-scope="{data}">
          <vs-tr :data="tr" v-for="(tr, ri) in data" :key="ri">

            <vs-td v-if="baseColumn" class="text-center">
              {{ getNo(ri) }}
            </vs-td>

            <vs-td v-for="(head, ci) in heads" :key="`table_list_${ri}_${head.name}`" class="text-center">
              <div v-if="typeof tr[head.name] === 'object'" style="display: grid; grid-template-columns: 1fr 24px;">
                <div v-if="tr[head.name] && tr[head.name].type === 'file'">
                  <a download target="_blank" :href="img.path" v-for="(img, index) in tr[head.name].files" :key="index" @click.stop>
                    <vs-icon icon-pack="feather" icon="icon-file" />
                  </a>
                </div>
                <div v-else-if="tr[head.name]">
                  <span :class="tr[head.name].type">{{ tr[head.name].value }}</span>
                  <span v-if="tr[head.name].type === 'up' || tr[head.name].type === 'down'" style="display: inline-flex; padding-top:2px; width:20px; height:20px; max-height:20px;">
                    <vs-image class="w-full" :src="require(`@/assets/images/icon/Icon-arrow_${tr[head.name].type}.png`)"/>
                  </span>
                </div>
              </div>
              <div v-else>
                {{ tr[head.name] }}
              </div>
            </vs-td>

            <vs-td v-if="baseColumn && !(boardId && boardId > 0)" class="text-center">
              {{ tr['결재상태'] }}
            </vs-td>

            <vs-td v-if="baseColumn && moveProject" class="text-center" @click.stop>
              <div class="flex justify-center " @click.stop>
                <vs-button type="border" icon="open_in_new" class="mr-1" @click.stop="()=>{onClickDetail(tr, '_blank')}"></vs-button>
                <vs-button type="border" @click.stop="()=>{onClickDetail(tr, 'self')}">{{ $t('button.바로가기') }}
                </vs-button>
              </div>
            </vs-td>

          </vs-tr>
        </template>
      </vs-table>

      <div class="vs-con-table">
        <div class="con-pagination-table vs-table--pagination">
          <k-pagination
            :total="listAll.length > 0 ? Math.floor((listAll.length-1)/perPage) + 1 : 1"
            :max-items="5"
            v-model="page" @change="onChangePage"></k-pagination>
        </div>
      </div>

    </vx-card>

    <popup-approval-process
      :show-popup="popup.approval"
      @closePopup="onClickClose"/>

    <popup-excel-download
      v-if="download"
      v-model="popup.excel"
      :list="excelList"
      :title="title"/>
  </div>
</template>

<script>
import PopupExcelDownload from '@/views/components/popup/PopupExcelDownload'
import PopupApprovalProcess from '@/views/content/approval/PopupApprovalProcess'
import SearchNav from '@/views/components/nav/SearchNav'
import KPagination from '@/views/components/kPagination/kPagination'

export default {
  name: 'TableListPage',
  components: {
    KPagination,
    SearchNav,
    PopupApprovalProcess,
    PopupExcelDownload
  },
  props: {
    detail:Function,
    list: {
      required: false,
      type: Array
    },
    useList: Boolean,
    baseColumn:{
      type: Boolean,
      default: true
    },
    bodyStyle: {
      type: String,
      default: 'card'
    },
    showNav: {
      type: Boolean,
      default: true
    },
    download: {
      type: Boolean | String,
      default: true
    },
    approval: {
      type: Boolean,
      default: true
    },
    create: {
      type: Boolean,
      default: true
    },
    createBtnLabel:{
      type: String,
      default: '신규작성'
    },
    moveProject: {
      type: Boolean,
      default: false,
    },
    moveDetail: {
      type: Boolean,
      default: true
    },
    moveNew: {
      type: Boolean,
      default: true
    },
    boardSlug: String,
    boardId: Number,
    routeC: String,
    routeU: String,


    nav: Object,
    heads: Array,
    getCol: Function
  },
  data () {
    return {
      popup: {
        excel: false,
        approval: false
      },
      page: 1,
      perPage: 10,
      total: 0,
      sortKey: '',
      asc: null,
      listAll: []
    }
  },
  watch:{
    list () {
      this.listAll = this.list;
    }
  },
  computed: {
    cardClass () {
      if (this.bodyStyle === 'none') {
        return 'none-card'
      }
      return ''
    },
    title () {
      if (typeof this.download === 'string') {
        return this.download
      }
      return 'unknown'
    },
    excelList () {
      const list = []

      for (const tr of this.listAll) {
        const obj = {}
        obj['projId'] = tr.project_id
        obj['postId'] = tr.post_id || tr.id
        if (this.boardId && this.boardId > 0) {
          obj['No'] = tr.id
        } else {
          obj['No'] = tr.post_id
        }
        for (let ci = 0; ci < this.heads.length; ci++) {
          obj[this.heads[ci].name] = this.getCol(ci, tr)
        }
        if (!(this.boardId && this.boardId > 0)) {
          if (tr.document_status) {
            obj['결재상태'] = tr.document_status.name
          } else {
            obj['결재상태'] = '-'
          }
        }
        obj['raw'] = tr
        list.push(obj)
      }

      list.sort((a, b) => {
        if (typeof a[this.sortKey] === 'object') {
          if (this.asc === 'desc') {
            return a[this.sortKey].value > b[this.sortKey].value ? -1 : a[this.sortKey].value < b[this.sortKey].value ? 1 : 0
          } else if (this.asc === 'asc') {
            return a[this.sortKey].value < b[this.sortKey].value ? -1 : a[this.sortKey].value > b[this.sortKey].value ? 1 : 0
          }
        } else {
          if (this.asc === 'desc') {
            return a[this.sortKey] > b[this.sortKey] ? -1 : a[this.sortKey] < b[this.sortKey] ? 1 : 0
          } else if (this.asc === 'asc') {
            return a[this.sortKey] < b[this.sortKey] ? -1 : a[this.sortKey] > b[this.sortKey] ? 1 : 0
          }
        }

        return 1
      })

      return list
    },

    realList () {
      let list = JSON.parse(JSON.stringify(this.excelList))

      const start = this.page * this.perPage
      const length = list.length
      list.splice(start, length - start)
      list.splice(0, start - this.perPage)
      return list
    }
  },
  mounted () {
    if (!this.useList) {
      this.loadList()
    }
  },
  methods: {
    getNo (index) {
      return this.total - (((this.page - 1) * this.perPage) + index)
    },

    async loadList () {
      let projectId = this.$route.params.proj_id
      if (this.nav.projectId) {
        projectId = this.nav.projectId
      }

      if (this.boardId && this.boardId > 0) {
        await this.loadListBoard(projectId)
      } else {
        await this.loadListApproval(projectId)
      }
    },

    async loadListBoard (projectId) {
      const boardId = this.boardId
      const page = 1
      const perPage = 10000
      const orderTarget = this.nav.orderTarget
      const orderDirection = this.nav.orderDirection

      let dateTarget = ''
      let dateBegin = ''
      let dateEnd = ''
      const keywords = []

      if (this.nav.dateTarget) {
        dateTarget = this.nav.dateTarget
      }


      if (this.nav.dateBegin) {
        dateBegin = this.getValue(this.$props, this.nav.dateBegin)
      }

      if (this.nav.dateEnd) {
        dateEnd = this.getValue(this.$props, this.nav.dateEnd)
      }

      if (this.nav.keyword.length > 0) {
        try {
          this.nav.keyword.map(word => {
            const methods = `${word}`.split('*')
            const key = methods[1].replace(/%*\[\:([^%]*)\]%*/, '$1')
            const value = this.getValue(this.$props, key)
            const query = methods[1].replace(/(%*)([^%]*)(%*)/, `$1${value}$3`)
            const keyword = `${methods[0]}*${query.trim()}`
            //const key
            if (value) {
              keywords.push(keyword)
            }
          })
        } catch (e) {
        }
      }

      await this.$store.dispatch('board/LOAD_POST_LIST', {
        projectId: projectId > 0 ? projectId : undefined,
        boardId,
        page,
        perPage,
        orderTarget,
        orderDirection,

        dateTarget,
        dateBegin,
        dateEnd,

        keyword: keywords
      })
      console.log('keywords', keywords)
      this.listAll = [...JSON.parse(JSON.stringify(this.$store.state.board.postListInfo.data))]
      this.total = this.$store.state.board.postListInfo.total;
      this.$emit('load', this.listAll)
    },

    async loadListApproval (projectId) {
      const boardSlug = this.boardSlug
      const page = 1
      const perPage = 10000
      const dateTarget = []
      const dateBegin = []
      const dateEnd = []
      const keywords = []
      const orderTarget = this.nav.orderTarget
      const orderDirection = this.nav.orderDirection

      if (this.nav.keyword.length > 0) {
        try {
          this.nav.keyword.map(word => {
            const methods = `${word}`.split('*')
            const key = methods[1].replace(/%*\[\:([^%]*)\]%*/, '$1')
            const value = this.getValue(this.$props, key)
            const query = methods[1].replace(/(%*)([^%]*)(%*)/, `$1${value}$3`)
            const keyword = `${methods[0]}*${query.trim()}`
            //const key
            if (value) {
              keywords.push(keyword)
            }
          })
        } catch (e) {
        }
      }

      if (this.nav.dateTarget) {
        dateTarget.push(...this.nav.dateTarget)
      }

      if (this.nav.dateBegin && this.nav.dateBegin.length > 0) {
        this.nav.dateBegin.map(key => {
          dateBegin.push(this.getValue(this.$props, key))
        })
      }

      if (this.nav.dateEnd) {
        this.nav.dateEnd.map(key => {
          dateEnd.push(this.getValue(this.$props, key))
        })
      }

      await this.$store.dispatch('approval/LOAD_POST_ALL', {
        boardSlug,
        projectId,
        page,
        perPage,
        dateTarget,
        dateBegin,
        dateEnd,
        keyword: keywords,
        orderTarget,
        orderDirection
      })
      this.listAll = [...JSON.parse(JSON.stringify(this.$store.state.approval.list))]
      this.total = this.$store.state.approval.postListInfo.total;
      this.$emit('load', this.listAll)
    },

    getValue (obj, keyPath) {
      const keys = `${keyPath}`.split('.')

      let value = obj
      for (const key of keys) {
        value = value[key]
      }
      return value
    },

    onClickSearch () {
      this.loadList()
    },
    onClickSort (sortKey, asc) {
      this.sortKey = sortKey
      this.asc = asc
    },
    onChangePage (page) {
      this.page = page
    },
    onClickDownload () {
      this.popup.excel = true
    },
    onClickApprovalLine () {
      this.popup.approval = true
    },
    onClickNew () {

      if (this.moveNew) {
        const boardSlug = this.boardSlug

        this.$router.push({
          name: this.routeC,
          params: {boardSlug}
        })
      } else {
        this.$emit('new')
      }
    },
    onClickClose () {
      const keys = Object.keys(this.popup)
      keys.map(key => {
        this.popup[key] = false
      })
    },
    onClickDetail (value, target) {
      const proj_id = value.projId
      const boardId = this.boardId
      const boardSlug = this.boardSlug
      const postId = value.postId
      const route = {
        name: this.routeU,
        params: {
          proj_id,
          boardId,
          boardSlug,
          postId
        }
      }

      if (this.moveProject) {
        if (target === 'self') {
          if (route.params.boardId === 50) {
            this.$router.push({name: route.name, params: {proj_id, postId, tab:'info'}})
          } else {
            this.$router.push(route)
          }
          return
        } else if (target === '_blank') {
          if (route.params.boardId === 50) {
            window.open(`/project/${proj_id}/plan/partners/info/${postId}`, '_blank')
          } else {
            const routeData = this.$router.resolve(route)
            window.open(routeData.href, '_blank')
          }
          return
        }
      } else if (this.moveDetail) {
        this.$router.push(route)
      }

      this.$emit('detail', value, target, route)
    }
  }
}
</script>

<style lang="scss" scoped>
.table-list-page {
  .page-head {
    min-width: 100px !important;
  }
}
</style>
<style lang="scss">
.none-card {
  box-shadow: none;
  border-radius: 0px;
  display: inline-block;

  .vx-card__body {
    padding:0px !important;
  }
}

span.up { color:#28C76F }
span.down { color:#EA5455 }
</style>
